module.exports = __webpack_public_path__ + "static/media/upload-mobil.e6e1ad20.jpg";